import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Save / cancel (or similar) pairs — stacked on mobile, side-by-side on sm+.
 */
export function FormActions({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        'flex w-full min-w-0 flex-col-reverse gap-2 pt-1 sm:flex-row sm:gap-3',
        '[&_button]:min-h-[44px] [&_button]:w-full [&_button]:touch-manipulation sm:[&_button]:flex-1',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
